import classnames from 'classnames';
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import './hui-date-picker.scss';
import { HUIDatePickerProps } from './types';

const HUIDatePicker: React.FC<HUIDatePickerProps> = ({ metadata, ...props }) => {
  /**
   * prevent default event to disable typing on the input
   */
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const formatWeekDay = (day: string) => day.slice(0, 1);

  return (
    <div className={classnames('hui-date-picker', { disabled: props.disabled })} {...metadata}>
      <DatePicker
        {...props}
        popperClassName="hui-date-picker-popover"
        formatWeekDay={formatWeekDay}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

HUIDatePicker.displayName = 'HUIDatePicker';

export default HUIDatePicker;
